import { useState} from 'react'
import {MdExpandLess} from "@react-icons/all-files/md/MdExpandLess";
import {MdExpandMore} from "@react-icons/all-files/md/MdExpandMore";
import classes from './filters-actief.module.scss'
import {ImCross} from "@react-icons/all-files/im/ImCross";
import {RiFilterOffFill} from "@react-icons/all-files/ri/RiFilterOffFill";
import {useTekstClient} from "hooks/useTekstClient";
import {useSetSearchParams} from "hooks/useSetSearchParams";
import {useSearchParams, useRouter} from 'next/navigation'
import useSWRImmutable from 'swr/immutable'

const fetchTagGroep = (url) => fetch(url, {credentials: 'include'}).then((res) => res.json());

export const FiltersActief = ({ }) => {
    const [expand, setExpand] = useState(true);
    const {tekst} = useTekstClient()
    const searchParams = useSearchParams()
    const {deleteParam, deleteParams} = useSetSearchParams()
    const router = useRouter()


    const filterTagGroep = searchParams.get('taggroep');


    const { data: tagGroep } = useSWRImmutable(filterTagGroep ? `${process.env.NEXT_PUBLIC_BACKEND}/api/taggroep/${filterTagGroep}`: null, fetchTagGroep, {refreshInterval: 0,
        revalidateIfStale: false,
        revalidateOnReconnect: true,
        revalidateOnFocus: false});


    return searchParams.size > 0 && <div className={classes.filterActiefComponent}>
        <div className={classes.headerContainer}>
            {expand
                ? <MdExpandLess onClick={() => setExpand(false)}/>
                : <MdExpandMore onClick={() => setExpand(true)}/>
            }
            <b>{tekst('pagina:support:kenniscentrum:filters:filtersactief')}</b>
            {<div className={classes.resetFilterIcon}><RiFilterOffFill title={'Reset filters'} onClick={() => {
                router.push(`/mijn-mkg/support/kenniscentrum`)
            }}/>
            </div>}

        </div>
        {expand && <div className={classes.filtersActiefContainer} suppressHydrationWarning>


            {/*taggroep*/}
            {filterTagGroep && <div className={classes.filterActief} onClick={() => {
                deleteParam('taggroep')
            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:filtersactief:zoeksuggestie')}: {tagGroep?.tags_in_taal?.length > 0 && tagGroep?.tags_in_taal[0]?.naam}</div>
            </div>}


            {/*tekst*/}
            {searchParams.get('tekst') && <div className={classes.filterActief} onClick={() => {
                deleteParam('tekst')

            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:filtersactief:zoekterm')}: {searchParams.get('tekst')}</div>
            </div>}


            {/*Mijn Favorieten*/}
            {searchParams.get('fav') && <div className={classes.filterActief} onClick={() => {
                deleteParam('fav')
            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:filtersactief:mijnfavorieten')}</div>
            </div>}

            {/*Video*/}
            {searchParams.get('vid') && <div className={classes.filterActief} onClick={() => {
                deleteParam('vid')
            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:video')}</div>
            </div>}


            {/*beschikbaarheid*/}
            {searchParams.get('unlock') && <div className={classes.filterActief} onClick={() => {
                deleteParam('unlock')
            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:filtersactief:beschikbaarheid')}
                    ({searchParams.get('unlock').split(',').length})
                </div>
            </div>}

            {/*Product*/}
            {searchParams.get('prod') && <div className={classes.filterActief} onClick={() => {
                deleteParams([{name: 'prod', value: null}, {name: 'vers', value: null}])
            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:filtersactief:producten')}
                    ({searchParams.get('prod').split(',').length})

                </div>
            </div>}

            {/*typen*/}
            {searchParams.get('typen') && <div className={classes.filterActief} onClick={() => {
                deleteParam('typen')
            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:filtersactief:type')}
                    ({searchParams.get('typen').split(',').length})
                </div>
            </div>}

            {/*categorie*/}
            {searchParams.get('cat') && <div className={classes.filterActief} onClick={()=>{
                deleteParam('cat')
            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:filtersactief:categorie')}
                    ({searchParams.get('cat').split(',').length})
                </div>
            </div>}

            {/*typen*/}
            {searchParams.get('kenmerk') && <div className={classes.filterActief} onClick={() => {
                deleteParam('kenmerk')

            }}>
                <div className={classes.filterActiefBtn}><ImCross/></div>
                <div className={classes.filterActiefTitel}>{tekst('pagina:support:kenniscentrum:filters:filtersactief:kenmerk')}
                    ({searchParams.get('kenmerk').split(',').length})
                </div>
            </div>}

        </div>
        }
        <div className={`border-b border-kleur-licht-grijs-blauw pb-[20px] mb-[20px]`}/>
    </div>
}